<template>
  <div>
    <Navbar title="联系我们" :default-bg="false"/>
    <div v-html="content"></div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";

export default {
  components: {
    Navbar
  },
  data() {
    return {
      content: ''
    };
  },
  mounted() {
    this.articlePhone()
  },

  computed: {},

  methods: {
    articlePhone() {
      this.$post('/article/contactUs').then((res) => {
        if (res.status == 200) {
          this.content = res.data
        }
      })
    }

  }
}

</script>
<style lang='less' scoped></style>